import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { component } from 'picoapp';
import Marquee from 'react-fast-marquee';
import { useMount } from 'ahooks';

const FooterMarquee = ({ ctx, el, data }) => {
  const [mainMenu, setMainMenu] = useState([]);

  useMount(() => {
    setMainMenu([
      'Fair Trade',
      'Chemical Free',
      'Sustainably Sourced',
      'Premium Acrylic',
      'Women Owned & Founded',
      'Business with a Purpose',
    ]);
  });

  return (
    <div>
      <Marquee autoFill={true} pauseOnHover={true} pauseOnClick={true} gradient={false} speed={35}>
        {mainMenu?.map((link, index) => {
          return (
            <div className="option" key={link}>
              {link}
            </div>
          );
        })}
      </Marquee>
    </div>
  );
};

export default component((node, ctx) => {
  if (!customElements.get('footer-marquee')) {
    customElements.define(
      'footer-marquee',
      class extends HTMLElement {
        connectedCallback() {
          // const root = createRoot(node);
          // const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          let rawDataEl = this.querySelector('script');
          let rawData = rawDataEl ? JSON.parse(rawDataEl.innerHTML) : null;
          const element = <FooterMarquee ctx={ctx} el={this} data={rawData}></FooterMarquee>;
          ReactDOM.render(element, node);
          // root.render(element);
        }
      }
    );
  }
});
